(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dunamis-capsules"] && !Shopify.designMode) return;
  try {
    


  
/* Partie Autre Capsule*/  
  
$(document).ready(function () {
  var Scrollbar = window.Scrollbar;
  Scrollbar.use(window.OverscrollPlugin);

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function updateActiveItems(scrollbar) {
    var mobile = isMobile();
    var offset = mobile ? scrollbar.offset.y : scrollbar.offset.x;
    var $items = $(scrollbar.containerEl).find('.js-scroll-list-item-capsule');

    $items.removeClass('item-focus-capsule item-next-capsule item-hide-capsule');

    for (var i = 0; i < $items.length; i++) {
      var $item = $($items[i]);
      var itemPosition = mobile ? $item.position().top : $item.position().left;
      var itemSize = mobile ? $item.outerHeight() : $item.outerWidth();

      if (itemPosition + itemSize / 2 >= offset) {
        $item.addClass('item-focus-capsule');
        $item.next().addClass('item-next-capsule');
        break;
      }
    }
  }

  $('.js-scroll-list-capsule').each(function () {
    var customScroll = Scrollbar.init(this, {
      alwaysShowTracks: false,
      plugins: {
        overscroll: true
      }
    });

    updateActiveItems(customScroll);

    customScroll.addListener(function () {
      updateActiveItems(customScroll);
    });

    $(window).on('resize', function () {
      customScroll.update();
      updateActiveItems(customScroll);
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dunamis-enseignements"] && !Shopify.designMode) return;
  try {
    

/* Script pour filtrer les résultats selon le prédicateur */
/*  document.addEventListener("DOMContentLoaded", function() {
    const authorLinks = document.querySelectorAll(".author-link");
    const videoItems = document.querySelectorAll(".scroll-list__item__horizontal");
    const videoItemsCapsules = document.querySelectorAll(".scroll-list__item__horizontal-capsule");

    authorLinks.forEach(author => {
        author.addEventListener("click", function(event) {
            event.preventDefault();
            const selectedAuthor = this.closest(".wrapper-predicateur").getAttribute("data-author");

            videoItems.forEach(video => {
                const videoAuthor = video.getAttribute("data-author");
                if (videoAuthor === selectedAuthor || selectedAuthor === null) {
                    video.style.display = "block";
                } else {
                    video.style.display = "none";
                }
            });
            videoItemsCapsules.forEach(video => {
                const videoAuthor = video.getAttribute("data-author");
                if (videoAuthor === selectedAuthor || selectedAuthor === null) {
                    video.style.display = "block";
                } else {
                    video.style.display = "none";
                }
            });
        });
    });
});*/

  
/* Script pour l'espace youtube, remplacer les vidéos par une autre */
/*  document.addEventListener("DOMContentLoaded", function() {
    const videoLinks = document.querySelectorAll(".video-link");
    const iframe = document.getElementById("youtubeIframe");

    videoLinks.forEach(link => {
      link.addEventListener("click", function(event) {
        event.preventDefault();
        const videoId = this.getAttribute("data-video");
        iframe.src = "https://www.youtube.com/embed/" + videoId;
      });
    });
  }); */
/* Partie Scroll Horizontal Left */
$(document).ready(function () {
  var Scrollbar = window.Scrollbar;

  Scrollbar.use(window.OverscrollPlugin);

  var customScroll = Scrollbar.init(document.querySelector('.js-scroll-list-horizontal'), {
    plugins: {
      overscroll: true,
    },
  });

  var listItem = $('.js-scroll-list-item-horizontal');

  listItem.eq(0).addClass('item-focus-horizontal');
  listItem.eq(1).addClass('item-next-horizontal');

  customScroll.addListener(function (status) {
    var top = status.offset.x; // Position horizontale
    var $lis = $('.js-scroll-list-item-horizontal');
    $lis.removeClass('item-focus-horizontal item-next-horizontal item-hide-horizontal');

    for (var i = 0; i < $lis.length; i++) {
      var $li = $($lis[i]);
      var liLeft = $li.position().left;

      if (liLeft > top) {
        $li.addClass('item-focus-horizontal');
        $li.next().addClass('item-next-horizontal');
        break;
      }
    }
  });
}); 
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dunamis-list-capsules"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    if (!window.Scrollbar || !window.jQuery) {
      return;
    }

    var Scrollbar = window.Scrollbar;

    if (window.OverscrollPlugin) {
      Scrollbar.use(window.OverscrollPlugin);
    }

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function updateActiveItems(scrollbar) {
      var mobile = isMobile();
      var offset = mobile ? scrollbar.offset.y : scrollbar.offset.x;
      var $items = $(scrollbar.containerEl).find('.js-scroll-list-item-capsule');

      $items.removeClass('item-focus-capsule item-next-capsule item-hide-capsule');

      for (var i = 0; i < $items.length; i++) {
        var $item = $($items[i]);
        var itemPosition = mobile ? $item.position().top : $item.position().left;
        var itemSize = mobile ? $item.outerHeight() : $item.outerWidth();

        if (itemPosition + itemSize / 2 >= offset) {
          $item.addClass('item-focus-capsule');
          $item.next().addClass('item-next-capsule');
          break;
        }
      }
    }

    $('.js-scroll-list-capsule').each(function () {
      if ($(this).data('capsule-scrollbar-ready')) {
        return;
      }

      $(this).data('capsule-scrollbar-ready', true);

      var customScroll = Scrollbar.init(this, {
        alwaysShowTracks: false,
        plugins: {
          overscroll: true
        }
      });

      updateActiveItems(customScroll);

      customScroll.addListener(function () {
        updateActiveItems(customScroll);
      });

      $(window).on('resize', function () {
        customScroll.update();
        updateActiveItems(customScroll);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dunamis-versets-multiples"] && !Shopify.designMode) return;
  try {
    


    
/* Partie Scroll Horizontal Left */
$(document).ready(function () {
  var Scrollbar = window.Scrollbar;

  Scrollbar.use(window.OverscrollPlugin);

  var customScroll = Scrollbar.init(document.querySelector('.js-scroll-list-horizontal-c-a'), {
    plugins: {
      overscroll: true,
    },
  });

  var listItem = $('.js-scroll-list-item-horizontal-c-a');

  listItem.eq(0).addClass('item-focus-horizontal-c-a');
  listItem.eq(1).addClass('item-next-horizontal-c-a');

  customScroll.addListener(function (status) {
    var top = status.offset.x; // Position horizontale
    var $lis = $('.js-scroll-list-item-horizontal-c-a');
    $lis.removeClass('item-focus-horizontal-c-a item-next-horizontal-c-a item-hide-horizontal-c-a');

    for (var i = 0; i < $lis.length; i++) {
      var $li = $($lis[i]);
      var liLeft = $li.position().left;

      if (liLeft > top) {
        $li.addClass('item-focus-horizontal-c-a');
        $li.next().addClass('item-next-horizontal-c-a');
        break;
      }
    }
  });
});
/* Partie JS VERTICALE SLIDER DROIT */
  $(document).ready(function () {
  var Scrollbar = window.Scrollbar;

  Scrollbar.use(window.OverscrollPlugin);

  var customScroll = Scrollbar.init(document.querySelector('.js-scroll-list-c-a'), {
    plugins: {
      overscroll: true
    }
  });

  var listItem = $('.js-scroll-list-item-c-a');

  // Vérifie le nombre d'éléments et affiche leurs positions
  console.log("Nombre d'éléments dans la liste:", listItem.length);
  listItem.each(function (index) {
    console.log(`Élément ${index}: position().top = `, $(this).position().top);
  });

  // Applique les classes initiales
  listItem.eq(0).addClass('item-focus-c-a');
  listItem.eq(1).addClass('item-next-c-a');

  customScroll.addListener(function (status) {
    var $content = $('.js-scroll-content-c-a');
    var viewportScrollDistance = status.offset.y;
    var viewportHeight = $content.height();
    var listHeight = 0;
    var $listItems = $content.find('.js-scroll-list-item-c-a');

    // Calcul de la hauteur totale des items
    $listItems.each(function () {
      listHeight += $(this).height();
    });

    var top = status.offset.y;
    var visibleCenterVertical = top;
    var parentTop = 1;
    var $lis = $('.js-scroll-list-item-c-a');
    var $focusLi;

    console.log("Défilement en cours... Position Y:", top);
    
    for (var i = 0; i < $lis.length; i++) {
      var $li = $($lis[i]);
      var liTop = $li.position().top;
      var liRelTop = liTop - parentTop;

      console.log(`Élément ${i} - liTop: ${liTop}, liRelTop: ${liRelTop}`);

      var distance = Math.abs(top - liRelTop);
      var maxDistance = $('.js-scroll-content-c-a').height() / 2;
      var distancePercent = distance / (maxDistance / 100);

      if (liRelTop + $li.parent().scrollTop() > top) {
        if (!$li.hasClass('item-focus-c-a')) {
          if (!$li.is(':first-child')) {
            $li.prev().addClass('item-hide-c-a'); // Évite de cacher le premier élément
          }

          console.log(`Ajout de item-focus-c-a à l'élément ${i}`);
          $lis.removeClass('item-focus-c-a item-next-c-a item-hide-c-a');

          $li.addClass('item-focus-c-a');
          $li.next().addClass('item-next-c-a');
        }
        break;
      }
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
